<!--p>
  <button mat-icon-button class="edit-row"  aria-label="Editar registro." (click)="add()">
    <mat-icon>add</mat-icon>
  </button>
</p-->
<div class="main-panel">
  <div class="action">
    <!--mat-form-field>
      <mat-label>Busca de Dados</mat-label>
      <input matInput type="text" [(ngModel)]="searchValue" (keyup)="find($event)">
      <button *ngIf="searchValue" matSuffix mat-icon-button aria-label="Clear" (click)="value=''">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field-->
    <h3>{{treename}}</h3>
    <div fxFlex></div>
    <div class="vl"></div>
    <mat-icon (click)="doInit(true)">refresh</mat-icon>
    <mat-icon (click)="cts.executeAll(list,true,productData)">add</mat-icon>
    <mat-icon (click)="cts.executeAll(list,false,null)">remove</mat-icon>
  </div>
  <div class="dropdown-divider"></div>
  <div class="tree">
    <custom-tree-view [items]="listSyncTemp | async"  [parent]="productData" [detail]="template" >
          
    </custom-tree-view>
  </div>
</div>
  
  <ng-template #template let-item="item" let-path="path">
    <div *ngIf="item.isopen && item.isvisible" >
      <form [formGroup]="getFormGroup(path)" >
        
        <mat-form-field [ngStyle]="{'margin-left':getMargin(item)}" *ngIf="item.enum !=null && item.enum.length > 0 && item.child.length == 0" appearance="outline">
        <mat-label>{{item.columnName}}</mat-label>
          <mat-select  [formControlName]="item.columnName" >
          <mat-option *ngFor="let tipo of item.enum" [value]="tipo">{{tipo}}</mat-option>   
          </mat-select>
        </mat-form-field>
        <button mat-mini-fab color="primary" *ngIf="item.multi">
          <mat-icon>add</mat-icon>
        </button>
  
        <mat-form-field [ngStyle]="{'margin-left':getMargin(item)}"  *ngIf="item.child.length == 0 && item.type == 'boolean'" appearance="outline">
        <mat-label>{{item.columnName}}</mat-label>
          <mat-select  [formControlName]="item.columnName" >
          <mat-option *ngFor="let tipo of [true,false]" [value]="tipo">{{tipo?'Verdadeiro':'Falso'}}</mat-option>   
          </mat-select>
        </mat-form-field>
  
        <mat-form-field [ngStyle]="{'margin-left':getMargin(item)}"  *ngIf="(item.enum ==null || item.enum.length == 0) &&  ((item.type != null && (item.type=='string' || item.type=='normalizedString')) || item.type=='anyURI' )" appearance="outline" >
          <mat-label>{{item.columnName}}</mat-label>
          <input matInput  [placeholder]="item.columnName" #input [formControlName]="item.columnName" >
          <button  matSuffix mat-icon-button aria-label="Clear" (click)="dynamicServices.getDataFromTable(getFormGroup(path),item.columnName, 'MKTPAMAZON',geralGroup, path.replaceAll('>','.'),'text' ) " matTooltip="Buscar Dados">
            <mat-icon>reply</mat-icon>
          </button>
          <button  matSuffix mat-icon-button aria-label="Clear" (click)="inp.value=''">
            <mat-icon>close</mat-icon>
          </button>
          </mat-form-field>
  
        <mat-form-field  [ngStyle]="{'margin-left':getMargin(item)}"  appearance="outline" *ngIf="(item.enum ==null || item.enum.length == 0) && item.child.length == 0 &&  (item.type == 'dateTime')"> 
        <mat-label>{{item.columnName}}</mat-label>
        <input matInput 
                [placeholder]="item.columnName" 
                [id]="item.columnName" 
                [matDatepicker]="dp" 
                [formControlName]="item.columnName" 
                />
        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
        <mat-datepicker #dp ></mat-datepicker>
        </mat-form-field>
        
        <mat-form-field [ngStyle]="{'margin-left':getMargin(item)}"  *ngIf="(item.enum ==null || item.enum.length == 0) &&  (item.type == 'positiveInteger' || item.type == 'integer' )" appearance="outline" >
        <mat-label>{{item.columnName}}</mat-label>
          <input matInput  [placeholder]="item.columnName" #input type = "number" [formControlName]="item.columnName">
          <button  matSuffix mat-icon-button aria-label="Clear" (click)="dynamicServices.getDataFromTable(getFormGroup(path),item.columnName, 'MKTPAMAZON', geralGroup, path.replaceAll('>','.'),'number') " matTooltip="Buscar Dados">
          <mat-icon>reply</mat-icon>
          </button>
          <button  matSuffix mat-icon-button aria-label="Clear" (click)="inp.value=''">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
  
        <mat-form-field  [ngStyle]="{'margin-left':getMargin(item)}"   *ngIf="(item.enum ==null || item.enum.length == 0) &&  (item.type == 'number' || item.type == 'decimal')" appearance="outline" >
        <mat-label>{{item.columnName}}</mat-label>
          <input matInput  [placeholder]="item.columnName" #input type = "number" [formControlName]="item.columnName" >
          <button matSuffix mat-icon-button aria-label="Clear" (click)="dynamicServices.getDataFromTable(getFormGroup(path),item.columnName, 'MKTPAMAZON', geralGroup, path.replaceAll('>','.'),'number') " matTooltip="Buscar Dados">
          <mat-icon>reply</mat-icon>
          </button>
          <button matSuffix mat-icon-button aria-label="Clear" (click)="inp.value=''">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </form>
    </div>
  
  </ng-template>